// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/impostazioni/centralino/configurazione?societaId=N',
    requestBody: null,
    response: '{ success: true, data: { configurazione: ConfigurazioneCentralino | null, verifiche: VerificaIntegrazione[], urlPredefinito } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/impostazioni/centralino/configurazione',
    requestBody: null,
    response: '{ success: true, data: ConfigurazioneCentralino }'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/centralino/verifica',
    requestBody: null,
    response: '{ success: true, data: { esitoOk, messaggio, durataMs } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
